import { initializeApp } from "firebase/app";
import {getFirestore} from 'firebase/firestore';
const firebaseConfig = {
  apiKey: "AIzaSyAfzEeS67-00xCDc07ZcP3O9getpejVIxs",
  authDomain: "react-app-d7e76.firebaseapp.com",
  projectId: "react-app-d7e76",
  storageBucket: "react-app-d7e76.appspot.com",
  messagingSenderId: "278613323738",
  appId: "1:278613323738:web:0812ea80baf80cbc72dae3"
};
const app = initializeApp(firebaseConfig);  
export const db=getFirestore(app);  